import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Global error handler for script loading errors (e.g., Cloudflare Insights, analytics)
// These are non-critical third-party scripts that may fail due to network issues, ad blockers, etc.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    // Suppress errors from third-party analytics/insights scripts
    if (event.target instanceof HTMLScriptElement) {
      const src = event.target.src || '';
      const isThirdPartyScript = 
        src.includes('cloudflareinsights.com') ||
        src.includes('clarity.ms') ||
        src.includes('googletagmanager.com') ||
        src.includes('google-analytics.com');
      
      if (isThirdPartyScript) {
        // Silently suppress these errors in production
        // They're non-critical and shouldn't break the app
        if (import.meta.env.DEV) {
          console.warn('[ScriptLoader] Third-party script failed to load:', src);
        }
        event.preventDefault();
        return false;
      }
    }
    
    // Suppress integrity hash mismatch errors for third-party scripts
    if (event.message?.includes('integrity') || event.message?.includes('sha512')) {
      const isThirdPartyError = 
        event.filename?.includes('cloudflareinsights.com') ||
        event.filename?.includes('clarity.ms');
      
      if (isThirdPartyError) {
        if (import.meta.env.DEV) {
          console.warn('[ScriptLoader] Integrity hash mismatch for third-party script:', event.filename);
        }
        event.preventDefault();
        return false;
      }
    }
  }, true); // Use capture phase to catch errors early

  // Handle CORS errors for third-party resources
  window.addEventListener('error', (event) => {
    if (event.message?.includes('CORS') || event.message?.includes('Cross-Origin')) {
      const isThirdPartyResource = 
        event.filename?.includes('cloudflareinsights.com') ||
        event.filename?.includes('clarity.ms') ||
        event.filename?.includes('supabase.co');
      
      // Only suppress CORS errors for analytics scripts, not for Supabase API
      if (isThirdPartyResource && !event.filename?.includes('supabase.co')) {
        if (import.meta.env.DEV) {
          console.warn('[ScriptLoader] CORS error for third-party script:', event.filename);
        }
        // Don't prevent default for CORS errors as they're informational
      }
    }
  }, true);
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
